import {
  GetGuestAccessTokenParams,
  GuestAccessResponse,
  GuestUser,
  UpdateGuestRepParams,
} from './guestAccess.types'
import { useMutation } from 'react-query'
import { AxiosError } from 'axios'
import { axiosInstanceIservices } from 'lib/services/config/axios-config'

export const getGuestAccessToken = async (
  params: GetGuestAccessTokenParams
): Promise<GuestAccessResponse> => {
  try {
    const response = await axiosInstanceIservices.post<GuestAccessResponse>(
      '/auth0/guest-token',
      params,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    return response.data
  } catch (error) {
    const axiosError = error as AxiosError<{ message: string }>
    console.error('Error in getGuestAccessToken:', error)

    if (axiosError.response?.data?.message) {
      throw new Error(axiosError.response.data.message)
    }

    throw new Error('Failed to get guest access token')
  }
}

export const useGetGuestAccessToken = () => {
  return useMutation<GuestAccessResponse, Error, GetGuestAccessTokenParams>(
    (params) => getGuestAccessToken(params)
  )
}

export const hasValidGuestToken = (): boolean => {
  const authResponse = localStorage.getItem('auth_response')
  const token = JSON.parse(authResponse || '{}').access_token
  const user = JSON.parse(localStorage.getItem('guest_user') || '{}')
  const expired = user?.exp && new Date(user.exp * 1000) < new Date()
  return !!token && token !== 'undefined' && !!user?.caseId && !expired
}

export const getGuestToken = (): GuestAccessResponse | null => {
  const authResponse = localStorage.getItem('auth_response')
  const token = JSON.parse(authResponse || '{}').access_token
  return {
    access_token: token,
    expires_in: JSON.parse(authResponse || '{}').expires_in,
    token_type: JSON.parse(authResponse || '{}').token_type,
    scope: JSON.parse(authResponse || '{}').scope,
    refresh_token: JSON.parse(authResponse || '{}').refresh_token,
    id_token: JSON.parse(authResponse || '{}').id_token,
    payload: JSON.parse(authResponse || '{}').payload,
  }
}

export const removeGuestToken = (): void => {
  localStorage.removeItem('auth_response')
  localStorage.removeItem('guest_user')
  localStorage.removeItem('procedure-filters')
}

export const getGuestUser = (): GuestUser | null => {
  return JSON.parse(localStorage.getItem('guest_user') || '{}')
}

export const updateGuestRepInfo = async ({
  userId,
  verificationToken,
  accessToken,
}: UpdateGuestRepParams): Promise<any> => {
  try {
    const response = await axiosInstanceIservices.post(
      '/auth0/update-guest-rep',
      { userId, verificationToken },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )

    return response.data
  } catch (error) {
    const axiosError = error as AxiosError<{ message: string }>
    console.error('Error in updateGuestRepInfo:', error)

    if (axiosError.response?.data?.message) {
      throw new Error(axiosError.response.data.message)
    }

    throw new Error('Failed to update guest rep information')
  }
}

export const useUpdateGuestRepInfo = () => {
  return useMutation<any, Error, UpdateGuestRepParams>((params) =>
    updateGuestRepInfo(params)
  )
}
